export const getBaseUrl = () => {
  return "./api";
};
